import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = { class: "flex flex-col h-full justify-center items-center" }

import {onMounted} from "vue";
import {useDisdiMaintenanceStore} from "@/stores/DisdiMaintenanceStore";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import Error from "@/components/Error";
import router from "@/router";
import {useGlobalStore} from "@/stores/GlobalStore";
import {SystemCompanySettings} from "@/models/SystemCompanySettings";
import {MiscService} from "@/utilities/services/entities/MiscService";
import LoadingSpinner from "@/components/LoadingSpinner.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'DisdiLogin',
  setup(__props) {

const globalStore = useGlobalStore();
const disdiStore = useDisdiMaintenanceStore();
const miscService = new MiscService();

//const getTokenAndLogin = async () => {
//  const idsUrl = globalStore.settings.startupConfig?.idsUrl;
//  const authService = new OAuthService(idsUrl, anabClientConfig.clientId, anabClientConfig.scopes, anabClientConfig.callback, anabClientConfig.silent);
//  await authService.login()
//}

onMounted(async ()=>{
      
  globalStore.resetState();
  globalStore.user = null;
  globalStore.token = "";

  disdiStore.currentDisdiId = router.currentRoute.value.params.id as string;

  const startupConfig = await miscService.getStartupConfig(ErrorLocationType.login);
  if (startupConfig === null) {
    return;
  }

  globalStore.settings.defaultHiddenColumns = startupConfig.preferenceInfo;
  globalStore.settings.systemCompanySettings = new SystemCompanySettings(startupConfig.companyName, startupConfig.companyIdCode) ;
  globalStore.settings.startupConfig = startupConfig.startupInfo;

  const returnUrl = encodeURIComponent("/disdi/maintain");
  router.push(`/login?returnUrl=${returnUrl}&viewName=Disdi`);

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Error), {
      errorLoc: _unref(ErrorLocationType).login
    }, null, 8, ["errorLoc"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('disdi.login.description')), 1),
      _createVNode(LoadingSpinner)
    ])
  ]))
}
}

})